// extracted by mini-css-extract-plugin
export default {"confirmCardBtn":"U--z","disabled":"V--z","label":"W--z"};